import { getFiltersConfig } from 'utils';
import useFeatureFlags from './useFeatureFlags';
import useListingData from './externalData/useListingData';
import useUser from './externalData/useUser';

export default () => {
    const [featureFlags] = useFeatureFlags({
        brandNameIndex: 'instantSearch.filters.brandNameIndex',
        has3xPaymentIndex: 'instantSearch.filters.has_3xPaymentIndex',
        sellerNameIndex: 'instantSearch.filters.sellerNameIndex',
        priceIndex: 'instantSearch.filters.priceIndex',
        deliveryIndex: 'instantSearch.filters.deliveryIndex',
        showCategoriesFilterOnSearch:
            'relevance.show.categories.filter.on.search',
    });
    const { isB2B } = useUser();
    const { listingData } = useListingData();
    const isSearch = listingData.type === 'search';

    return getFiltersConfig({
        featureFlags,
        isB2B,
        isSearch,
    });
};
